import Cameras from "./Cameras";

export default Cameras;